
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ImageErrorFallbackProps {
  onRetry?: () => void;
  message?: string;
}

const ImageErrorFallback: React.FC<ImageErrorFallbackProps> = ({ 
  onRetry, 
  message = "Kuvan lataaminen epäonnistui" 
}) => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center bg-gray-100 text-gray-500">
      <AlertCircle className="w-8 h-8 mb-2 text-red-500" />
      <p className="text-sm text-center mb-3">{message}</p>
      {onRetry && (
        <Button size="sm" variant="outline" onClick={onRetry}>
          Valitse toinen kuva
        </Button>
      )}
    </div>
  );
};

export default ImageErrorFallback;
